import QuinielazoService from "@/services/QuinielazoService";

export const namespaced = true;

export const state = {
	equipos: [],
	equipo: {}
};

export const mutations = {
	SET_EQUIPOS(state, equipos) {
		state.equipos = equipos
	},
	SET_EQUIPO(state, equipo){
		state.equipo = equipo
	}
};

export const actions = {
	fetchEquipos({ commit }) {
		QuinielazoService.getEquipos()
		.then(resp => {
			commit("SET_EQUIPOS", resp.data);
		})
		.catch(err => {
			console.log(err);
		});
	},
	fetchEquipo({commit, dispatch}, equipo){
		return QuinielazoService.getEquipo(equipo)
		.then(resp => {
			commit('SET_EQUIPO',resp.data)
		})
		.catch(err => {
			dispatch('notification/add',{
				type: 'error',
				message: 'No se pudo cargar el equipo' + err
			},{root: true})
		})
	},
	saveEquipo({dispatch}, equipo){
		if (equipo.id != undefined) {
			return QuinielazoService.updateEquipo(equipo)
			.then(() => {
				dispatch('notification/add',{
					message: 'Se guardo el equipo'
				}, {root: true})

				//Si se agrego logo
				if (equipo.logo) {
					console.log(equipo.logo)
					dispatch('postLogo',{id: equipo.id, logo: equipo.logo})
				}
			})
			.catch(err => {
				dispatch('notification/add',{
					type: 'error',
					message: 'Hubo un error al guardar' + err
				}, {root: true})	
			})
		}else{
			return QuinielazoService.postEquipo(equipo)
			.then(resp => {
				console.log(resp)
				dispatch('notification/add',{
					message: 'Se guardo el equipo'
				}, {root: true})

				//Si se agrego logo
				if (equipo.logo) {
					dispatch('postLogo',{id: resp.data.id, logo: equipo.logo})
				}
			})
			.catch(err => {
				dispatch('notification/add',{
					type: 'error',
					message: 'Hubo un error al guardar'+ err
				}, {root: true})	
			})
		}
	},
	postLogo({ dispatch }, data){
		let fd = new FormData();
		fd.append('id',data.id)
		fd.append('logo',data.logo)
		console.log(fd)

		return QuinielazoService.updateEquipoImg(data.id, fd)
		.then(() => {
			console.log('se guardo el logo :P')
		})
		.catch(err => {
			console.log(err,err.response)
			dispatch("notification/add", {
				type: 'error',
				message: 'No se pudo guardar el logo' + err.message
			}, { root: true });						
		})
	}
};

export const getters = {
	getEquiposById: state => id => {
		return state.equipos.find(equipo => equipo.id === id);
	}
};
